import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

const supportedLanguages = ['en', 'ar', 'tr', 'de', 'fr', 'es', 'it', 'ru'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    debug: false,
    resources: messages,
    detection: {
      // Detection order: localStorage first (user preference), then browser language
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'preferredLanguage',
      caches: ['localStorage'],
      // Map browser language codes to our supported codes
      // e.g. "en-US" -> "en", "ar-SA" -> "ar"
      convertDetectedLanguage: (lng: string) => {
        const base = lng.split('-')[0].toLowerCase();
        return supportedLanguages.includes(base) ? base : 'en';
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

// Apply RTL direction on initial load
const applyDirection = (lang: string) => {
  document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = lang;
};

applyDirection(i18n.language);

i18n.on('languageChanged', (lng) => {
  applyDirection(lng);
});

export default i18n;
